import api from '../api.js';

export const marketStoryRequests = {
  getAllByMonthAndYear: (month, year) => {
    return api.get(`/marketstories/filter?month=${month}&year=${year}`, { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/marketstories/${id}`, { cache: 'no-store' });
  },
  create: (marketStoriesDto) => {
    return api.post(`/marketstories`, marketStoriesDto);
  },
  update: (marketStoriesDto, id) => {
    return api.put(`/marketstories/${id}`, marketStoriesDto);
  },
  delete: (id) => {
    return api.delete(`/marketstories/${id}`);
  },
};

export default marketStoryRequests;
